// Ported verbatim from halco-ops-v10.jsx. Formatting is what invoices and the
// fleet list are read from, so it must not drift during the migration.

export const fmtMoney = (n) =>
  "$" + (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtDate = (s) => {
  if (!s) return "—";
  const [y, m, d] = String(s).split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", {
    month: "short", day: "numeric", year: "numeric",
  });
};

/** Local calendar date as YYYY-MM-DD. en-CA formats that way natively. */
export const todayStr = () => new Date().toLocaleDateString("en-CA");

export const EQ_CATEGORIES = [
  "Skid steer", "Trencher", "Excavator", "Attachment", "Trailer",
  "Compaction", "Aerial lift", "Generator", "Other",
];
